import { render, staticRenderFns } from "./sala-espera.vue?vue&type=template&id=6f0c7dfc&"
import script from "./sala-espera.vue?vue&type=script&lang=js&"
export * from "./sala-espera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports